import React, { createContext, useEffect, useState } from 'react';

const windowSize = createContext(null);

export const WindowProvider = ({ children }) => {
    const [ WindowSize, setWindowSize ] = useState( window.innerWidth );
    useEffect( () =>
    {
        function setwindowwidth ()
        {
            setWindowSize( window.innerWidth )
            
        }
        window.addEventListener( "resize", setwindowwidth );
        // cleanup function
        return () =>
        {
            window.removeEventListener( "resize", setwindowwidth );
           
        }
        
    }, [] );

    return (
        <windowSize.Provider value={{ WindowSize, setWindowSize}}>
            {children}
        </windowSize.Provider>
    );
};

export default windowSize;